import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  permissionCard: (isActive: boolean) => (theme: Theme) => ({
    backgroundColor: isActive ? theme.colors.white : theme.colors.neutral[300],
    padding: '0.625rem',
    display: 'flex',
    flexDirection: 'column',
    border: isActive
      ? `0.125rem solid ${theme.colors.neutral[200]}`
      : `0.125rem solid ${theme.colors.neutral[400]}`,

    borderRadius: '0.5rem',
    height: '100%',
    opacity: isActive ? 1 : 0.25,
    pointerEvents: isActive ? 'initial' : 'none',
  }),

  permissionCardHeader: (isActive: boolean) => (theme: Theme) => ({
    backgroundColor: isActive
      ? theme.colors.neutral[50]
      : theme.colors.neutral[300],

    borderBottom: isActive
      ? `0.125rem solid ${theme.colors.neutral[200]}`
      : `0.125rem solid ${theme.colors.neutral[400]}`,
    borderRadius: '0.5rem 0.5rem 0 0',
    padding: '0.625rem 1rem',
    margin: '-0.625rem -0.625rem 0',
    fontWeight: 'bold',
    display: 'inline-flex',
    justifyContent: 'space-between',
  }),

  permissionCardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0.313rem 0',
    pl: '0.5rem',
    width: '100%',
  },

  permissionCardLabel: {
    mr: '0.625rem',
  },

  permissionCardControl: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  permissionCardSelect: {
    backgroundColor: '#ffffff',
    mt: 0,
  },

  checkboxes: {
    whiteSpace: 'nowrap',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    cursor: 'pointer',
  },

  inputWrapper: {
    ml: '0.625rem',
    position: 'relative',
    flexGrow: 1,
    pr: '5rem',
  },

  horizontalDivider: (isActive: boolean) => (theme: Theme) => ({
    border: isActive
      ? `0.063rem solid ${theme.colors.neutral[100]}`
      : `0.063rem solid ${theme.colors.neutral[400]}`,
  }),

  dropdown: muiSelectStyles.filterSelect,

  orgUnitSelectorLabel: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    cursor: 'pointer',
  },
};
